import { render, staticRenderFns } from "./setPasswrod1.vue?vue&type=template&id=0afe58ce&"
import script from "./setPasswrod1.vue?vue&type=script&lang=js&"
export * from "./setPasswrod1.vue?vue&type=script&lang=js&"
import style0 from "./setPasswrod1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports